import _ from 'lodash';
import React from 'react';
import { InfoBlock } from '~/components';
import { Overlay } from './Overlay';

export function HelpOverlay( props ) {
  return (
    <Overlay title="Help" {...props}>
      <InfoBlock id="helo" />
    </Overlay>
  );
}
HelpOverlay.propTypes = _.omit( Overlay.propTypes, 'title' );
